/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Automatic/AppRegistrationAutomaticComponent" />

import * as React from "react";

import { ICredentialTypeState } from "DistributedTaskUI/ServiceEndpoints/Editor/Stores/CredentialTypeStore";
import { AzureRMAutoServicePrincipalEndpointEditorComponent, IAzurRMComponentProps } from "DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/AzureRMAutoServicePrincipalEndpointEditorComponent";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IdentityCredentialTypeComponent } from "../Manual/IdentityCredentialTypeComponent";
import { ResourceGroupSecondaryTextComponent } from "./ResourceGroupSecondaryTextComponent";
import { SubscriptionSecondaryTextComponent } from "./SubscriptionSecondaryTextComponent";
import { IServiceEndpointAuthenticationSchemeExtended } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";
import { EndpointsEditorPanelUtils } from "DistributedTaskUI/ServiceEndpoints/Editor/Utils/EndpointsEditorPanelUtils";
import { EndpointsEditorActionsCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/EndpointsEditorActionsCreator";
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { ActionsCreatorInstanceIds } from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";

export class AppRegistrationAutomaticComponent extends VssComponent<IAzurRMComponentProps, ICredentialTypeState> {

    public render(): React.ReactNode {
        return (<React.Fragment>
            {!this.props.isUpdateForm && <IdentityCredentialTypeComponent/>}
            <div className={!this.props.isUpdateForm ? "default-input-margin-top" : ""}>
                <AzureRMAutoServicePrincipalEndpointEditorComponent
                    {...this.props}
                    titleClassName={"font-semibold bolt-formitem-label"}
                    disableDetailsHeader={true}
                    subscriptionSecondaryText={() => <SubscriptionSecondaryTextComponent />}
                    resourceGroupSecondaryText={() => <ResourceGroupSecondaryTextComponent />}
                />
            </div>
        </React.Fragment>);
    }
 }
